const moment = require('moment');
/*@ngInject*/
const FormTemplateSettingsController = function ($rootScope, $scope, $state, $stateParams, $uibModalInstance, localization, coreConstant, formViewerConstant, coreMediator, configurationMediator, formMediator, formTemplateType, fieldType, formTemplateStatus, options, dateUtil, authorizationConstants, navigationStateModel, configurationConstant, configurationActionsUtil, formViewerModel, uiFormTemplateModel, currentUserModel) {

    var originalUniqueName = null;

        $scope.viewModel = {
            promptValue: '',
            title: '',
            confirmButtonLabel: '',
            formTemplateTypesPrompt:'',
            formTemplateTypeList: null,
            productList: [],
            selectedProductsValue: '',
            selectedFormTemplateType: null,
            defaultRequired: 'required',
            requiredRadioButtonValue: 'required',
            productRadioButtonValue: 'allProducts',
            displayProductSelection: true,
            displayProductSelectionDropDown: false,
            uniqueName: '',
            displayName: '',
            ordering: -1,
            isAllProductsSelected: true,
            effectiveDateRangeCheckBox: false,
            effectiveDateRange: null,
            effectiveDateRangeBegin: null,
            effectiveDateRangeEnd: null,
            type: null,
            formTemplateConfig: null,
            itemName: 'formTemplateSetting',
            selectedProducts: [],
            allowDirectNavigation: false,
            formRepeatable: false,
            displayStatusVersionBox: false,
            canManageForms: false,
            includedInEndorsement: false,
            proposalLevel: false,
            conditional: false,
            selectorWidgetMode: 'forms',
            precedingFieldFormTemplateUniqueName: null,
            precedingFieldVariableName: null,
            selectedFormTemplate: null,
            triggerRuleName: null,
            displayLinkForm: false,
            linkFormList: null,
            selectedLinkFormItem: null,
            linkFormPlaceholder: '',
            isInProduction: false
        };

    $scope.viewModel.canManageForms = currentUserModel.hasAuthorization(authorizationConstants.MANAGE_FORMS);

    function init() {
        localization.getTranslationByKey('formTemplateSettings').then(function (translations) {
            var formStructure;
            if (!_.isNil(options.formTemplateId)) {
                formStructure = formViewerModel.getFormStructure(options.formTemplateId);

                if (formStructure && formStructure.uiFormTemplate) {
                    parseFormTemplateConfig(formStructure.uiFormTemplate);
                } else if (_.isNil(uiFormTemplateModel.getUiFormTemplate()) || uiFormTemplateModel.getUiFormTemplate().id !== parseInt($stateParams.uiFormTemplateId)) {
                    configurationMediator.getFormTemplateById($stateParams.uiFormTemplateId).then(function (uiFormTemplate) {
                        uiFormTemplateModel.setUiFormTemplate(uiFormTemplate);
                        parseFormTemplateConfig(uiFormTemplate);
                    });
                } else {
                    parseFormTemplateConfig(uiFormTemplateModel.getUiFormTemplate());
                }
            } else {
                $scope.viewModel.selectedFormTemplateType = formTemplateType.APPLICATION;
                loadData();
            }

                $scope.viewModel.promptValue = translations.selectProducts;
                $scope.viewModel.title = _.isNil(options.formTemplateId) ? translations.newTemplateTitle : translations.title;
                $scope.viewModel.confirmButtonLabel = _.isNil(options.formTemplateId) ? translations.createFormTemplate : translations.saveButton;
                $scope.viewModel.linkFormPlaceholder = translations.linkFormPlaceholder;
                $scope.viewModel.formTemplateTypesPrompt = translations.formTemplateTypesPrompt

            function parseFormTemplateConfig(formTemplateConfig) {
                $scope.viewModel.formTemplateConfig = formTemplateConfig;
                $scope.viewModel.conditional = formTemplateConfig.conditional;
                $scope.viewModel.uniqueName = formTemplateConfig.formTemplate.uniqueName;
                $scope.viewModel.displayName = formTemplateConfig.formTemplate.displayName;
                $scope.viewModel.precedingFieldFormTemplateUniqueName = formTemplateConfig.precedingFieldFormTemplateUniqueName;
                $scope.viewModel.precedingFieldVariableName = formTemplateConfig.precedingFieldVariableName;
                $scope.viewModel.ordering = formTemplateConfig.ordering;
                $scope.viewModel.displayStatusVersionBox = true;
                $scope.viewModel.statusValue = translations.status[formTemplateConfig.formTemplate.status];
                $scope.viewModel.versionValue = formTemplateConfig.formTemplate.version;
                $scope.viewModel.dynamicName = formTemplateConfig.formTemplate.dynamicNameTemplate;
                $scope.viewModel.staticName = formTemplateConfig.formTemplate.staticName;
                $scope.viewModel.flags = formTemplateConfig.formTemplate.flags;
                $scope.viewModel.allowDirectNavigation = formTemplateConfig.formTemplate.allowDirectNavigation;
                $scope.viewModel.formRepeatable = formTemplateConfig.formRepeatable;
                $scope.viewModel.selectedFormTemplateType = formTemplateConfig.formTemplate.type;

                originalUniqueName = $scope.viewModel.uniqueName;

                if (formTemplateConfig.formTemplate.root) {
                    $scope.viewModel.requiredRadioButtonValue = $scope.viewModel.conditional ? 'conditionallyRequired' : 'required';
                } else {
                    $scope.viewModel.requiredRadioButtonValue = 'supplemental';
                }

                $scope.viewModel.displayIncludeInEndorsements = $scope.displayIncludeInEndorsements();
                $scope.viewModel.includedInEndorsement = formTemplateConfig.formTemplate.includedInEndorsement;
                $scope.viewModel.displayIncludeInEndorsements = $scope.displayProposalLevel();
                $scope.viewModel.proposalLevel = formTemplateConfig.formTemplate.proposalLevel;

                if (!_.isNil(formTemplateConfig.formTemplate.effectiveDateRangeBegin) || !_.isNil(formTemplateConfig.formTemplate.effectiveDateRangeEnd)) {
                    $scope.viewModel.effectiveDateRange = dateUtil.formatUtcDateRangeString(formTemplateConfig.formTemplate.effectiveDateRangeBegin, formTemplateConfig.formTemplate.effectiveDateRangeEnd);
                    $scope.viewModel.effectiveDateRangeCheckBox = true;
                    $scope.viewModel.effectiveDateRangeBegin = formTemplateConfig.formTemplate.effectiveDateRangeBegin;
                    $scope.viewModel.effectiveDateRangeEnd = formTemplateConfig.formTemplate.effectiveDateRangeEnd;
                }

                if (_.isEmpty(formTemplateConfig.formTemplate.productTemplates)) {
                    $scope.viewModel.displayProductSelectionDropDown = false;
                    $scope.viewModel.isAllProductsSelected = true;
                    $scope.viewModel.selectedProducts = null;
                    $scope.viewModel.productRadioButtonValue = 'allProducts';
                } else {
                    $scope.viewModel.selectedProducts = formTemplateConfig.formTemplate.productTemplates;
                    $scope.viewModel.displayProductSelectionDropDown = true;
                    $scope.viewModel.productRadioButtonValue = 'multiProducts';
                    $scope.viewModel.isAllProductsSelected = false;
                }
                $scope.viewModel.sortFormNames = formTemplateConfig.sortRepeatableFormNames;
                $scope.viewModel.status = formTemplateConfig.formTemplate.status;

                if (formTemplateConfig.formTemplate.status === formTemplateStatus.IN_PRODUCTION) {
                    $scope.viewModel.isInProduction = true;
                }

                loadData();
            }

            function loadData() {
                var typeDynamicDataSetParams = {
                        name: 'Advanced Filter form template types'
                    },
                    linkFormDynamicDataSetParams = {
                        name: 'Application Repeating Form Templates'
                    };

                $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);

                coreMediator.getDynamicDataSetItems(typeDynamicDataSetParams).then(function (result) {
                    $scope.viewModel.formTemplateTypeList = result;

                    _.each(result, function (item) {

                        if (_.parseInt(item.value) === $scope.viewModel.selectedFormTemplateType) {
                            $scope.viewModel.selectedFormTemplateName = item.name;
                            $scope.viewModel.selectedFormTemplateType = item.type;
                            $scope.viewModel.selectedFormTemplate = item;
                            $scope.onSelectFormTemplateType();
                        }
                    });
                });

                coreMediator.getDynamicDataSetItems(linkFormDynamicDataSetParams).then(function (result) {
                    $scope.viewModel.linkFormList = result;
                    if (isFormTemplateConfigExist()) {
                        _.each(result, function (item) {
                            if (item.value === $scope.viewModel.formTemplateConfig.formTemplate.linkFormTemplateUniqueName) {
                                $scope.viewModel.selectedLinkFormItem = item;
                            }
                        });
                    }
                });

                function isFormTemplateConfigExist() {
                    return !_.isNil($scope.viewModel.formTemplateConfig);
                }
            }
        });
    }

    $scope.handleFormTemplateVisibilityChange = function (value) {
        localization.getTranslationByKey('formTemplateSettings').then(function (translations) {
            if (value !== 'required') {
                $scope.viewModel.formRepeatable = false;
                $scope.viewModel.triggerRuleName = value === 'supplemental' ? translations.triggerRuleNameSupplemental : translations.triggerRuleNameConditionallyRequired;
            }
        });
    };

    $scope.displayIncludeInEndorsements = function () {
        return $scope.viewModel.selectedFormTemplateType === formTemplateType.APPLICATION && $scope.viewModel.requiredRadioButtonValue !== 'supplemental';
    };

    $scope.displayProposalLevel = function () {
        return ($scope.viewModel.selectedFormTemplateType === formTemplateType.RATING ||
            $scope.viewModel.selectedFormTemplateType === formTemplateType.PRICING ||
            $scope.viewModel.selectedFormTemplateType === formTemplateType.QUOTING ||
            $scope.viewModel.selectedFormTemplateType === formTemplateType.UNDERWRITER_BINDING);
    };

    $scope.handleUniqueNameBlur = function () {
        if (originalUniqueName !== $scope.viewModel.uniqueName && $scope.viewModel.formTemplateConfig) {
            configurationActionsUtil.showFormReferences('formReferencesUniqueNameChange', $scope.viewModel.formTemplateConfig.id, originalUniqueName, /*showConfirmationButtons*/true).then(
                function () {
                    // Confirm button pressed
                },
                function () {
                    // Cancel button pressed
                    $scope.viewModel.uniqueName = originalUniqueName;
                });
        }
    };

        $scope.onSelectFormTemplateType = function () {
            if(!_.isNil($scope.viewModel.selectedFormTemplate)) {
                $scope.viewModel.selectedFormTemplateType = parseInt($scope.viewModel.selectedFormTemplate.value);
                $scope.viewModel.selectedFormTemplateName = $scope.viewModel.selectedFormTemplate.name;
                $scope.handleLinkFormVisibilityChange();

                var ownerUri = 'com.firstbest.underwriting.form.FormTemplateType:' + $scope.viewModel.selectedFormTemplate.value,
                    typeDynamicDataSetParams = {
                        name: 'Product Templates By FormTemplateType',
                        ownerUri: ownerUri
                    },
                    count = 0,
                    productValues = '';

                coreMediator.getDynamicDataSetItems(typeDynamicDataSetParams).then(function (result) {
                    $scope.viewModel.displayProductSelection = result.length > 0;

                    if (!_.isNil(options.formTemplateId)) {
                        _.each($scope.viewModel.formTemplateConfig.formTemplate.productTemplates, function (product) {
                            if (count === 0) {
                                productValues = product.id;
                            } else {
                                productValues += '::' + product.id;
                            }
                            count++;
                        });

                        $scope.viewModel.selectedProductsValue = productValues;
                    }
                    $scope.viewModel.productList = result;

                });
            }
        };

    $scope.onEffectiveDateRangeCheckBoxClicked = function () {
        $scope.viewModel.effectiveDateRange = null;
        $scope.viewModel.effectiveDateRangeBegin = null;
        $scope.viewModel.effectiveDateRangeEnd = null;
    };

    $scope.dateRangeUpdated = function (value) {
        $scope.viewModel.effectiveDateRangeBegin = dateUtil.parseDateRangeStartDateToMilliseconds(value);
        $scope.viewModel.effectiveDateRangeEnd = dateUtil.parseDateRangeEndDateToMilliseconds(value);
    };

    $scope.onRepeatableClick = function () {
        $scope.handleLinkFormVisibilityChange();
    };

    $scope.handleLinkFormVisibilityChange = function () {
        if ($scope.viewModel.selectedFormTemplateType !== formTemplateType.RATING || !$scope.viewModel.formRepeatable) {
            $scope.viewModel.selectedLinkFormItem = null;
            $scope.viewModel.displayLinkForm = false;
        }
        else {
            $scope.viewModel.displayLinkForm = true;
        }
    };

    $scope.onConfirm = function () {
        var formStructure,
            uiFormTemplate = {};

        if (!_.isNil(options.formTemplateId)) {
            formStructure = formViewerModel.getFormStructure(options.formTemplateId);

            if (formStructure) {
                configurationActionsUtil.populateUiFormTemplateModel(options.formTemplateId);
                uiFormTemplate = formStructure.uiFormTemplate;
            } else {
                uiFormTemplate = uiFormTemplateModel.getUiFormTemplate();
            }
        } else {
            uiFormTemplate.formTemplate = {};
            uiFormTemplate.formTemplate.status = formTemplateStatus.DRAFT;
        }

        uiFormTemplate.formTemplate.type = $scope.viewModel.selectedFormTemplateType;
        uiFormTemplate.formTemplate.uniqueName = $scope.viewModel.uniqueName;
        uiFormTemplate.formTemplate.displayName = $scope.viewModel.displayName;
        uiFormTemplate.formTemplate.includedInEndorsement = $scope.displayIncludeInEndorsements() ? $scope.viewModel.includedInEndorsement : false;
        uiFormTemplate.formTemplate.proposalLevel = $scope.displayProposalLevel() ? $scope.viewModel.proposalLevel : false;

        if ($scope.viewModel.effectiveDateRangeCheckBox) {
            uiFormTemplate.formTemplate.effectiveDateRangeBegin = $scope.viewModel.effectiveDateRangeBegin;
            uiFormTemplate.formTemplate.effectiveDateRangeEnd = $scope.viewModel.effectiveDateRangeEnd;
        } else {
            uiFormTemplate.formTemplate.effectiveDateRangeBegin = null;
            uiFormTemplate.formTemplate.effectiveDateRangeEnd = null;
        }

        if ($scope.viewModel.displayProductSelection) {
            if ($scope.viewModel.isAllProductsSelected) {
                uiFormTemplate.formTemplate.productTemplates = null;
                uiFormTemplate.formTemplate.appliesToAllProductTemplates = true;
            } else {
                uiFormTemplate.formTemplate.productTemplates = $scope.viewModel.selectedProducts;
                uiFormTemplate.formTemplate.appliesToAllProductTemplates = false;
            }
        }

        uiFormTemplate.formTemplate.root = $scope.viewModel.requiredRadioButtonValue !== 'supplemental';

        if ($scope.viewModel.requiredRadioButtonValue === 'supplemental') {
            uiFormTemplate.precedingFieldFormTemplateUniqueName = $scope.viewModel.precedingFieldFormTemplateUniqueName;
            uiFormTemplate.precedingFieldVariableName = $scope.viewModel.precedingFieldVariableName;
        } else {
            uiFormTemplate.precedingFieldFormTemplateUniqueName = null;
            uiFormTemplate.precedingFieldVariableName = null;
        }

        uiFormTemplate.conditional = $scope.viewModel.requiredRadioButtonValue === 'conditionallyRequired';
        if ($scope.viewModel.requiredRadioButtonValue === 'required') {
            uiFormTemplate.triggerRule = null;
        } else if (_.isNil(uiFormTemplate.triggerRule)) {
            uiFormTemplate.triggerRule = {
                objectUri: '/Rule',
                name: $scope.viewModel.triggerRuleName,
                condition: {
                    objectUri: '/CompositeCondition',
                    subconditions: []
                }
            };
        }

        if (!$scope.viewModel.formRepeatable || $scope.viewModel.requiredRadioButtonValue !== 'required') {
            uiFormTemplate.sortRepeatableFormNames = false;
            uiFormTemplate.formTemplate.dynamicNameTemplate = '';
            uiFormTemplate.formTemplate.staticName = '';
            //for non-repeatable forms, this property should be set to true
            uiFormTemplate.formTemplate.allowDirectNavigation = true;
            $scope.viewModel.formRepeatable = false;
            uiFormTemplate.formRepeatable = false;
        } else {
            uiFormTemplate.formRepeatable = $scope.viewModel.formRepeatable;
            uiFormTemplate.formTemplate.dynamicNameTemplate = $scope.viewModel.dynamicName;
            uiFormTemplate.formTemplate.staticName = $scope.viewModel.staticName;
            uiFormTemplate.sortRepeatableFormNames = $scope.viewModel.sortFormNames;
            uiFormTemplate.formTemplate.allowDirectNavigation = $scope.viewModel.allowDirectNavigation;
        }

        uiFormTemplate.formTemplate.linkFormTemplateUniqueName = $scope.viewModel.selectedLinkFormItem ? $scope.viewModel.selectedLinkFormItem.value : null;
        uiFormTemplate.formTemplate.flags = $scope.viewModel.flags;
        uiFormTemplate.ordering = $scope.viewModel.ordering;

        if (_.isNil(options.formTemplateId)) {
            uiFormTemplate.formTemplate.version = 1;

            formMediator.buildNewUiSectionList(uiFormTemplate.formTemplate.type).then(function (result) {
                uiFormTemplate.sections = result;
                formMediator.clearIdsFromSectionList(uiFormTemplate.sections);

                configurationMediator.createFormTemplate(uiFormTemplate).then(function (result) {
                    configurationActionsUtil.handleUiFormTemplateSave(result, false);
                    if (result.id) {
                        var navigationModel = {
                            parentState: 'configuration.formTemplateBrowser',
                            currentState: 'configuration.formEditor.form',
                            data: {
                                uiFormTemplateId: result.id
                            }
                        };

                        $state.go('configuration.formEditor.form', {uiFormTemplateId: result.id});
                        navigationStateModel.saveViewState(navigationModel.parentState, navigationModel);
                        $uibModalInstance.close();
                    }
                });
            });
        } else {
            uiFormTemplate.id = $scope.viewModel.formTemplateConfig.id;
            configurationMediator.updateFormTemplate(uiFormTemplate, $scope.viewModel.formTemplateConfig.id).then(function (result) {
                configurationActionsUtil.handleUiFormTemplateSave(result, true);
                if (_.isNil(formStructure)) {
                    uiFormTemplateModel.setUiFormTemplate(result);
                }
                $uibModalInstance.close();
            });
        }
    };

    $scope.handleProductClick = function (event) {
        $scope.viewModel.isAllProductsSelected = event.currentTarget.value === 'allProducts';
        $scope.viewModel.selectedProductsValue = '';
        $scope.viewModel.selectedProducts = [];
        $rootScope.$broadcast(coreConstant.event.MULTI_SELECT_CLEAR, $scope.viewModel.itemName);

        if ($scope.viewModel.isAllProductsSelected) {
            $scope.viewModel.displayProductSelectionDropDown = false;
        } else {
            $scope.viewModel.displayProductSelectionDropDown = true;
        }
    };

    $scope.getSelectedProductName = function () {
        if (!_.isNil($scope.viewModel.selectedProducts) && $scope.viewModel.selectedProducts.length === 0 && !$scope.viewModel.isAllProductsSelected) {
            return '';
        }
        return 'product';
    };

    $scope.isRepeatableCheckboxEnabled = function () {
        return $scope.canEnableRepeatableCheckbox();
    };

    $scope.canEnableRepeatableCheckbox = function () {
        return !$scope.viewModel.isInProduction && $scope.viewModel.canManageForms && $scope.viewModel.requiredRadioButtonValue === 'required';
    };

    $scope.canEnableConfirmButton = function () {
        const hasSelectedFormTemplate = !_.isNil($scope.viewModel.selectedFormTemplate);
        const hasDisplayName = !_.isEmpty($scope.viewModel.displayName);
        const hasUniqueName = !_.isEmpty($scope.viewModel.uniqueName);

        const isEffectiveDateActive = $scope.viewModel.effectiveDateRangeCheckBox;
        const hasEffectiveDateRangeBegin = !_.isNil($scope.viewModel.effectiveDateRangeBegin);
        const hasEffectiveDateRangeEnd = !_.isNil($scope.viewModel.effectiveDateRangeEnd);
        const isEffectiveDateValid = isEffectiveDateActive ? (hasEffectiveDateRangeBegin || hasEffectiveDateRangeEnd) : true;

        const isSupplemental = $scope.viewModel.requiredRadioButtonValue === 'supplemental';
        const hasPrecedingFieldFormTemplateUniqueName = !_.isEmpty($scope.viewModel.precedingFieldFormTemplateUniqueName);
        const hasPrecedingFieldVariableName = !_.isNil($scope.viewModel.precedingFieldVariableName);
        const isSupplementalValid = isSupplemental ? (hasPrecedingFieldFormTemplateUniqueName && hasPrecedingFieldVariableName) : true;

        const hasEmptySelectedProductList = _.size($scope.viewModel.selectedProducts) === 0;
        const isAllProductSelected = $scope.viewModel.isAllProductsSelected;
        const isProductSelectionValid = !isAllProductSelected ? !hasEmptySelectedProductList : true;

        return (
            hasSelectedFormTemplate &&
            hasDisplayName &&
            hasUniqueName &&
            isEffectiveDateValid &&
            isProductSelectionValid &&
            isSupplementalValid
        );
    };

    $scope.$on('modal.closing', function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $scope.onCancel = function () {
        $uibModalInstance.close();
    };

    $scope.$on(coreConstant.event.MULTI_SELECT_UPDATED, _.debounce(function (event, itemName) {
        var productObj = {};
        if (itemName === $scope.viewModel.itemName) {
            $scope.viewModel.selectedProducts = [];
            _.each($scope.viewModel.productList, function (product) {
                if (product.selected) {
                    productObj = {};
                    productObj.id = product.value;
                    productObj.name = product.name;
                    $scope.viewModel.selectedProducts.push(productObj);
                }
            });
        }
    }), 500);

    $scope.$on(configurationConstant.event.SELECTOR_WIDGET_UPDATED, function (event, item1Name, item2) {
        $scope.viewModel.precedingFieldFormTemplateUniqueName = item1Name;
        $scope.viewModel.precedingFieldVariableName = item2.fieldName;
    });

    init();
};

angular.module('umCore')
    .controller('formTemplateSettingsController', FormTemplateSettingsController);
